import { createUseExternalEvents as e } from "./index326.mjs";
const [o, t] = e("mantine-notifications"), i = t("show");
t("hide");
t("clean");
t("cleanQueue");
const a = t("update");
export {
  t as createEvent,
  i as showNotification,
  a as updateNotification,
  o as useNotificationsEvents
};
